// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".terms{max-width:800px;margin:100px auto;line-height:1.5em}", ""]);
// Exports
module.exports = exports;
